import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useRecoilValue, useRecoilValueLoadable } from 'recoil';
import useFormatter from '../../common/useFormatter';
import {
  actualityAggregatedStatsTotal,
  actualityAggregatedStatsUserSelectedMetrics,
} from '../store/actuality.kpi.state';
import { ActualityAggregatedHqExtendedDataRow } from '../store/actuality.kpi.types';
import { getActualityAggregationMetricDescriptors } from '../store/feedMetrics';

function isValueValid(
  data: ActualityAggregatedHqExtendedDataRow,
  key: keyof ActualityAggregatedHqExtendedDataRow,
) {
  const value = _.get(data, key);
  return !_.isNil(value) && (!_.isNumber(value) || value !== 0);
}

function useActualityAggregationMetricDescriptors() {
  const { t } = useTranslation('feed');
  const formatter = useFormatter();
  const totalStatsLoadable = useRecoilValueLoadable(
    actualityAggregatedStatsTotal,
  );
  const userSelectedMetrics = useRecoilValue(
    actualityAggregatedStatsUserSelectedMetrics,
  );
  const userSelectedMetricsSet = new Set(userSelectedMetrics);
  const aggMetricDescriptors = getActualityAggregationMetricDescriptors(
    t,
    formatter,
  );

  const hasTotalStats = totalStatsLoadable.state === 'hasValue';
  const totalStats = hasTotalStats ? totalStatsLoadable.contents : null;

  const effectiveAggMetricDescriptors = _.filter(
    aggMetricDescriptors,
    desc =>
      userSelectedMetricsSet.has(desc.id as any) &&
      (hasTotalStats ? isValueValid(totalStats, desc.id as any) : true),
  );
  return _.keyBy(effectiveAggMetricDescriptors, 'id');
}

export default useActualityAggregationMetricDescriptors;
